import React from 'react';
import IconComponent from 'ui/src/components/Icon';
import twMerge from 'utilities/src/twMerge';

interface Props {
  onClick: () => void;
  classes?: string;
}

export default function SearchButton({ onClick, classes }: Props) {
  return (
    <button
      type="button"
      className={twMerge('mdL:flex mdL:items-center mdL:gap-4 p-1.5', classes)}
      onClick={onClick}
    >
      <span className="mdL:block site-paragraph-m hidden">Search</span>
      <IconComponent iconName="Search" className="bg-current" />
    </button>
  );
}
